




























































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    ValidationObserver,
  },
  data() {
    return {
      formModel: {
        email: null,
        first_name: null,
        last_name: null,
      },
      formError: null,
      inProgress: null,
    };
  },
  methods: {
    async submit() {
      try {
        this.inProgress = true;
        await this.$store.dispatch('setting/createStudent', this.formModel);
        this.$parent.$emit('finish');
        this.$emit('close');
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_ADDED_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_ADD_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.inProgress = false;
      }
    },
  },
});
